import caseFold from './lexicon-case-fold.json'

const folds: Readonly<Record<string, string>> = caseFold.mappings

/** NFKC → full default Unicode C+F case fold → NFKC. */
export function normalizeLexiconTrigramText(text: string): string {
  return Array.from(text.normalize('NFKC'), char => {
    const code = (char.codePointAt(0) ?? 0).toString(16).toUpperCase().padStart(4, '0')
    return folds[code] ?? char
  }).join('').normalize('NFKC')
}

/** pg_trgm word padding; windows count Unicode characters, not UTF-16 units. */
export function lexiconTrigrams(text: string): string[] {
  const trigrams = new Set<string>()
  for (const word of normalizeLexiconTrigramText(text).match(/[\p{L}\p{N}\p{M}]+/gu) ?? []) {
    const chars = Array.from('  ' + word + ' ')
    for (let index = 0; index + 2 < chars.length; index++) {
      trigrams.add(chars.slice(index, index + 3).join(''))
    }
  }
  return [...trigrams].toSorted()
}

/** pg_trgm similarity: intersection / union of distinct trigrams. */
export function lexiconTrigramSimilarity(left: string, right: string): number {
  const a = new Set(lexiconTrigrams(left))
  const b = new Set(lexiconTrigrams(right))
  let shared = 0
  for (const trigram of a) if (b.has(trigram)) shared++
  const union = a.size + b.size - shared
  return union === 0 ? 0 : shared / union
}

/** Escape LIKE metacharacters: prefix affects rank only, never eligibility. */
export function lexiconPrefixPattern(text: string): string {
  return text.replaceAll(/[\\%_]/g, char => '\\' + char) + '%'
}
